import { useState } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import logo from "../../assets/logo.png";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [loginOpen, setLoginOpen] = useState(false);

  const handleLogin = (type) => {
    setLoginOpen(false);

    if (type === "web") {
      window.open("https://portal.pfalogistics.com/", "_blank");
    } else if (type === "app") {
      window.open("https://portal.pfalogistics.com/applogin", "_blank");
    }
  };

  return (
    <>
      {menuOpen && (
        <div className="nav-overlay" onClick={() => setMenuOpen(false)} />
      )}

      {loginOpen && (
        <div className="login-overlay" onClick={() => setLoginOpen(false)}>
          <div className="login-modal" onClick={(e) => e.stopPropagation()}>
            <h3>Select Login Type</h3>
            <button onClick={() => handleLogin("web")}>Portal Login</button>
            <button onClick={() => handleLogin("app")}>App Login</button>
          </div>
        </div>
      )}

      <header className="navbar">
        <div className="navbar-container">

          <Link to="/" onClick={() => setMenuOpen(false)}>
            <img src={logo} alt="PFA Logistics" className="logo" />
          </Link>

          <div
            className={`hamburger ${menuOpen ? "active" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span />
            <span />
            <span />
          </div>

          <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
            <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>
            <Link to="/about" onClick={() => setMenuOpen(false)}>About Us</Link>
            <Link to="/tracking" onClick={() => setMenuOpen(false)}>Tracking</Link>
            <Link to="/services" onClick={() => setMenuOpen(false)}>Services</Link>
            <Link to="/contact" onClick={() => setMenuOpen(false)}>Contact</Link>

            <button
              className="login-btn mobile-login"
              onClick={() => setLoginOpen(true)}
            >
              LOGIN
            </button>
          </nav>

          <button
            className="login-btn desktop-login"
            onClick={() => setLoginOpen(true)}
          >
            LOGIN
          </button>

        </div>
      </header>
    </>
  );
};

export default Navbar;
 